// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file automations/update_min_max.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.UpdateMinMaxRequest
 */
export class UpdateMinMaxRequest extends Message<UpdateMinMaxRequest> {
  /**
   * Unique identifier for the item
   *
   * @generated from field: int32 automation_id = 1;
   */
  automationId = 0;

  /**
   * New minimum quantity for the item
   *
   * @generated from field: float min_quantity = 2;
   */
  minQuantity = 0;

  /**
   * New maximum quantity for the item
   *
   * @generated from field: float max_quantity = 3;
   */
  maxQuantity = 0;

  /**
   * Whether the automation is enabled for this item
   *
   * @generated from field: bool is_automated = 4;
   */
  isAutomated = false;

  /**
   * Safety stock level for the item
   *
   * @generated from field: float safety_stock = 5;
   */
  safetyStock = 0;

  constructor(data?: PartialMessage<UpdateMinMaxRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UpdateMinMaxRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "automation_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "min_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "max_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "is_automated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "safety_stock", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMinMaxRequest {
    return new UpdateMinMaxRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMinMaxRequest {
    return new UpdateMinMaxRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMinMaxRequest {
    return new UpdateMinMaxRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMinMaxRequest | PlainMessage<UpdateMinMaxRequest> | undefined, b: UpdateMinMaxRequest | PlainMessage<UpdateMinMaxRequest> | undefined): boolean {
    return proto3.util.equals(UpdateMinMaxRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.UpdateMinMaxResponse
 */
export class UpdateMinMaxResponse extends Message<UpdateMinMaxResponse> {
  constructor(data?: PartialMessage<UpdateMinMaxResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UpdateMinMaxResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateMinMaxResponse {
    return new UpdateMinMaxResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateMinMaxResponse {
    return new UpdateMinMaxResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateMinMaxResponse {
    return new UpdateMinMaxResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateMinMaxResponse | PlainMessage<UpdateMinMaxResponse> | undefined, b: UpdateMinMaxResponse | PlainMessage<UpdateMinMaxResponse> | undefined): boolean {
    return proto3.util.equals(UpdateMinMaxResponse, a, b);
  }
}

